// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';

export const PageStatus = t.enums({
    COMPLETE: 'COMPLETE',
    LOADING: 'LOADING',
    ERROR: 'ERROR'
}, 'PageStatus');
